"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "player-status-and-res" };
const _hoisted_2 = { class: "player-status" };
const _hoisted_3 = { class: "player-info-details" };
const _hoisted_4 = ["title"];
const _hoisted_5 = {
    key: 0,
    class: "icon-first-player"
};
const _hoisted_6 = { class: "player-played-cards" };
const _hoisted_7 = { class: "player-played-cards-top" };
const _hoisted_8 = { class: "played-cards-elements" };
const _hoisted_9 = { class: "played-cards-count" };
const _hoisted_10 = ["data-tooltip"];
const _hoisted_11 = { class: "tag-count-display" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_player_status = (0, vue_1.resolveComponent)("player-status");
    const _component_PlayerResources = (0, vue_1.resolveComponent)("PlayerResources");
    const _component_AppButton = (0, vue_1.resolveComponent)("AppButton");
    const _component_PlayerTags = (0, vue_1.resolveComponent)("PlayerTags");
    const _component_PlayerAlliedParty = (0, vue_1.resolveComponent)("PlayerAlliedParty");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    const _directive_trim_whitespace = (0, vue_1.resolveDirective)("trim-whitespace");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: (0, vue_1.normalizeClass)(_ctx.getClasses())
    }, [
        (0, vue_1.createElementVNode)("div", _hoisted_1, [
            (0, vue_1.createElementVNode)("div", _hoisted_2, [
                (0, vue_1.createElementVNode)("div", _hoisted_3, [
                    (0, vue_1.createElementVNode)("div", {
                        class: "player-info-name",
                        onClick: _cache[0] || (_cache[0] =
                            (...args) => (_ctx.togglePlayerDetails && _ctx.togglePlayerDetails(...args)))
                    }, (0, vue_1.toDisplayString)(_ctx.playerSymbol + _ctx.player.name), 1),
                    ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.getCorporationName(), (corporationName, index) => {
                        return (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", {
                            onClick: _cache[1] || (_cache[1] =
                                (...args) => (_ctx.togglePlayerDetails && _ctx.togglePlayerDetails(...args))),
                            key: index
                        }, [
                            (0, vue_1.createElementVNode)("div", {
                                class: "player-info-corp",
                                title: _ctx.$t(corporationName)
                            }, (0, vue_1.toDisplayString)(corporationName), 9, _hoisted_4)
                        ])), [
                            [_directive_i18n]
                        ]);
                    }), 128))
                ]),
                (0, vue_1.createElementVNode)("div", null, [
                    (_ctx.firstForGen && _ctx.playerView.players.length > 1)
                        ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_5, [...(_cache[2] || (_cache[2] = [
                                (0, vue_1.createTextVNode)("1st", -1)
                            ]))])), [
                            [_directive_i18n]
                        ])
                        : (0, vue_1.createCommentVNode)("", true),
                    (0, vue_1.withDirectives)((0, vue_1.createVNode)(_component_player_status, {
                        timer: _ctx.player.timer,
                        showTimer: _ctx.playerView.game.gameOptions.showTimers,
                        liveTimer: _ctx.playerView.game.phase !== _ctx.Phase.END,
                        firstForGen: _ctx.firstForGen,
                        actionLabel: _ctx.actionLabel
                    }, null, 8, ["timer", "showTimer", "liveTimer", "firstForGen", "actionLabel"]), [
                        [_directive_trim_whitespace]
                    ])
                ])
            ]),
            (0, vue_1.withDirectives)((0, vue_1.createVNode)(_component_PlayerResources, { player: _ctx.player }, null, 8, ["player"]), [
                [_directive_trim_whitespace]
            ]),
            (0, vue_1.createElementVNode)("div", _hoisted_6, [
                (0, vue_1.createElementVNode)("div", _hoisted_7, [
                    (0, vue_1.createElementVNode)("div", _hoisted_8, [
                        _cache[3] || (_cache[3] = (0, vue_1.createElementVNode)("div", { class: "played-cards-icon hiding-card-button active" }, null, -1)),
                        _cache[4] || (_cache[4] = (0, vue_1.createElementVNode)("div", { class: "played-cards-icon hiding-card-button automated" }, null, -1)),
                        _cache[5] || (_cache[5] = (0, vue_1.createElementVNode)("div", { class: "played-cards-icon hiding-card-button event" }, null, -1)),
                        (0, vue_1.createElementVNode)("div", _hoisted_9, (0, vue_1.toDisplayString)(_ctx.numberOfPlayedCards()), 1)
                    ])
                ]),
                (0, vue_1.createVNode)(_component_AppButton, {
                    class: "played-cards-button",
                    size: "tiny",
                    onClick: _ctx.togglePlayerDetails,
                    title: _ctx.buttonLabel()
                }, null, 8, ["onClick", "title"])
            ]),
            (0, vue_1.createElementVNode)("div", {
                class: (0, vue_1.normalizeClass)(["tag-display player-board-blue-action-counter", _ctx.tooltipCss]),
                "data-tooltip": _ctx.$t('The number of available actions on active cards')
            }, [
                _cache[6] || (_cache[6] = (0, vue_1.createElementVNode)("div", { class: "tag-count tag-action-card" }, [
                    (0, vue_1.createElementVNode)("div", { class: "blue-stripe" }),
                    (0, vue_1.createElementVNode)("div", { class: "red-arrow" })
                ], -1)),
                (0, vue_1.createElementVNode)("span", _hoisted_11, (0, vue_1.toDisplayString)(_ctx.availableBlueActionCount()), 1)
            ], 10, _hoisted_10)
        ]),
        (0, vue_1.createVNode)(_component_PlayerTags, {
            player: _ctx.player,
            playerView: _ctx.playerView,
            hideZeroTags: _ctx.hideZeroTags,
            isTopBar: _ctx.isTopBar
        }, null, 8, ["player", "playerView", "hideZeroTags", "isTopBar"]),
        (0, vue_1.createVNode)(_component_PlayerAlliedParty, { player: _ctx.player }, null, 8, ["player"])
    ], 2));
}
